import { render, staticRenderFns } from "./JoinType.vue?vue&type=template&id=6a8d5896"
import script from "./JoinType.vue?vue&type=script&lang=js"
export * from "./JoinType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8d5896')) {
      api.createRecord('6a8d5896', component.options)
    } else {
      api.reload('6a8d5896', component.options)
    }
    module.hot.accept("./JoinType.vue?vue&type=template&id=6a8d5896", function () {
      api.rerender('6a8d5896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/JoinType.vue"
export default component.exports